








import { Component, Prop, Vue } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { RoomMember } from '@/class/roomMember'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'

@Component({
  components: {
    BtnSquare
  }
})
export default class GameMenu extends Vue {
  @Prop() game!: Game;
  @Prop() self!: RoomMember;
  @Prop() isGallary!: boolean;

  setNextState () {
    if (this.game.isGameover) return

    this.game.setNextState()
  }

  get isGameMaster () {
    return this.game.masterId === this.self.id && !this.isGallary
  }
}
